<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="2">
                <strong>{{ $t('AccountCirculation') }}</strong>

              </CCol>
              <CCol col="4">
                <CSelect
                    :options="[{label:$t('all'),value:1},{label:$t('user'),value:2}]"
                    :value.sync="selected_option"/>

              </CCol>

            </CRow>
          </CCardHeader>
          <CCardBody>
            <AllPersonsTurnoversReport v-show="selected_option==1"/>
            <PersonsTurnoversReport v-show="selected_option==2"/>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../../main';
// import the styles
// import the styles
import AllPersonsTurnoversReport from "./AllPersonsTurnoversReport.vue";
import PersonsTurnoversReport from "./PersonsTurnoversReport.vue";

export default {
  name: 'Login',
  components: {
    AllPersonsTurnoversReport,
    PersonsTurnoversReport,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      selected_option: 1,
    }
  },
  created() {
  },
  mounted() {
    bus.$on("change_tajmi_all_to_one", (data) => {
      // alert(data);
      this.selected_option = 2

    });
  },
  watch: {},
  methods: {}
}

</script>
